import { useQuery } from '@tanstack/react-query';

import { useCurrentScope } from '../../../shared/scope/useCurrentScope.js';

import { getContactsQueryKey, listContacts, type ListContactsFilters } from '../api/contacts.client.js';

export function useContacts(filters: ListContactsFilters = {}) {
  const scope = useCurrentScope();
  const workspaceId = scope?.workspaceId ?? 'anonymous';

  return useQuery({
    queryKey: getContactsQueryKey(workspaceId, filters),
    queryFn: () => listContacts(filters),
    enabled: scope !== null,
  });
}
